import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-dialog',
  standalone: false,
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss',
})
export class ErrorDialogComponent {

  readonly dialogRef = inject(MatDialogRef<ErrorDialogComponent>);
  readonly data = inject(MAT_DIALOG_DATA)

  constructor() { }

  close() {
    this.dialogRef.close();
  }
}
